module.exports = __webpack_public_path__ + "img/settings.8092f126.svg";